import { ArrowDown, ArrowUp, Trash2, Undo2 } from "lucide-react";

import { Button } from "~/components/ui/button";
import { cn } from "~/lib/cn";

export function ArrayItemCard({
  index: _index,
  isFirst,
  isLast,
  isDeleted,
  onMoveUp,
  onMoveDown,
  onToggleDelete,
  itemLabel,
  children,
}: {
  index: number; // available for consumer use (e.g., aria-labels, keys)
  isFirst: boolean;
  isLast: boolean;
  isDeleted: boolean;
  onMoveUp: () => void;
  onMoveDown: () => void;
  onToggleDelete: () => void;
  itemLabel: string; // e.g. "tag", "benefit" — used for accessible button names
  children: React.ReactNode;
}) {
  return (
    <div
      className={cn(
        "rounded-lg border border-gray-200 p-4",
        isDeleted && "opacity-50",
      )}
    >
      <div className="mb-2 flex items-center justify-end gap-1">
        <Button
          type="button"
          variant="ghost"
          size="icon"
          disabled={isFirst || isDeleted}
          aria-label={`Move ${itemLabel} up`}
          onClick={onMoveUp}
        >
          <ArrowUp className="h-4 w-4" />
        </Button>
        <Button
          type="button"
          variant="ghost"
          size="icon"
          disabled={isLast || isDeleted}
          aria-label={`Move ${itemLabel} down`}
          onClick={onMoveDown}
        >
          <ArrowDown className="h-4 w-4" />
        </Button>
        <Button
          type="button"
          variant="ghost"
          size="icon"
          aria-label={
            isDeleted ? `Restore ${itemLabel}` : `Remove ${itemLabel}`
          }
          onClick={onToggleDelete}
        >
          {isDeleted ? (
            <Undo2 className="h-4 w-4" />
          ) : (
            <Trash2 className="h-4 w-4" />
          )}
        </Button>
      </div>
      <div className={cn(isDeleted && "pointer-events-none")}>{children}</div>
    </div>
  );
}
